/**
 * Iter XX.222 — Performance Capture client library.
 *
 * Talks to /api/performances/*. All calls return null on a 404
 * (feature flag off) so UI surfaces render nothing in production.
 */
const _base = () => process.env.REACT_APP_BACKEND_URL;

function _auth() {
  const t = (typeof window !== "undefined" && window.localStorage)
    ? window.localStorage.getItem("gully_token") : null;
  return t ? { Authorization: `Bearer ${t}` } : {};
}

async function _fetch(path, opts = {}) {
  const r = await fetch(`${_base()}/api/performances${path}`, {
    ...opts,
    headers: {
      "Content-Type": "application/json",
      ..._auth(),
      ...(opts.headers || {}),
    },
  });
  if (r.status === 404) return { _disabled: true };
  const body = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(body?.detail || `HTTP ${r.status}`);
  return body;
}

export async function fetchPendingPerformances() {
  try {
    const r = await _fetch("/pending");
    return r._disabled ? null : r.candidates;
  } catch { return null; }
}

export async function confirmPerformance(candidate_id,
                                            { opposition, date_iso } = {}) {
  return _fetch("/confirm", {
    method: "POST",
    body: JSON.stringify({ candidate_id, opposition, date_iso }),
  });
}

export async function dismissPerformance(candidate_id) {
  return _fetch("/dismiss", {
    method: "POST", body: JSON.stringify({ candidate_id }),
  });
}

export async function enrichPerformance(match_id, { opposition, date_iso } = {}) {
  return _fetch("/enrich", {
    method: "POST",
    body: JSON.stringify({ match_id, opposition, date_iso }),
  });
}

export async function manualPerformance({ batting, bowling, opposition, date_iso, session_id }) {
  return _fetch("/manual", {
    method: "POST",
    body: JSON.stringify({ batting, bowling, opposition, date_iso, session_id }),
  });
}
